// ── Nova interface (Etapa 6): em qual aba mora cada conversa ──────────────────
// Princípio da Ana: cada conversa mora na aba da sua ORIGEM (Leads, Presencial,
// Prospecção). Quando o mesmo telefone aparece em mais de um lugar da mesma
// loja, vale o registro mais ANTIGO (a origem original). Sem registro nenhum,
// devolve "inbox" (a Central continua existindo como rede de segurança,
// só não aparece no menu da nova interface).

function digitos(v) { return String(v || "").replace(/\D/g, ""); }
export function telefoneComparavel(v) {
  let d = digitos(v);
  if ((d.length === 12 || d.length === 13) && d.startsWith("55")) d = d.slice(2);
  if (d.length === 10) d = d.slice(0, 2) + "9" + d.slice(2);
  return d.length === 11 ? d : null;
}
function quando(v) {
  if (v == null || v === "") return Infinity;
  const t = typeof v === "number" ? v : Date.parse(v);
  return Number.isFinite(t) ? t : Infinity;
}

export function conversaDaOrigem({ storeId, phone, leads = [], clients = [], prospeccao = [], leadBelongsToStore = null }) {
  const alvo = telefoneComparavel(phone);
  const sid = Number(storeId);
  if (!alvo || !Number.isFinite(sid)) return null;
  const candidatos = [];
  for (const c of clients || []) {
    if (Number(c?.storeId) === sid && telefoneComparavel(c.phone || c.telefone) === alvo) {
      candidatos.push({
        moduleId:"kanban", storeId:Number(c.storeId), phone:c.phone || c.telefone,
        record:c, t:quando(c.createdAt || c.data_criacao || c.criadoEm), ordem:1,
      });
    }
  }
  for (const l of leads || []) {
    // A loja responsável deve vir dos campos explícitos do lead. Se eles
    // divergirem do consultor, falha fechado; não infere autorização do dono.
    const responsibleStoreValue = l?.lojaAtual ?? l?.storeId;
    const hasExplicitResponsibleStore = responsibleStoreValue != null && responsibleStoreValue !== "";
    const explicitResponsibleStoreId = Number(
      responsibleStoreValue
    );
    const daLoja = hasExplicitResponsibleStore
      ? explicitResponsibleStoreId === sid
        && (!leadBelongsToStore || leadBelongsToStore(l, sid))
      : Boolean(leadBelongsToStore?.(l, sid));
    if (daLoja && telefoneComparavel(l?.telefone || l?.phone) === alvo) {
      const responsibleStoreId = hasExplicitResponsibleStore ? explicitResponsibleStoreId : sid;
      candidatos.push({
        moduleId:"leads",
        storeId:responsibleStoreId,
        channelStoreId:Number(l?.whatsappStoreId ?? l?.lojaOrigem ?? l?.storeId) || responsibleStoreId,
        recordId:l?.id == null ? null : String(l.id),
        phone:l.telefone || l.phone,
        record:l, t:quando(l.data_criacao || l.createdAt || l.criadoEm), ordem:2,
      });
    }
  }
  for (const p of prospeccao || []) {
    if (Number(p?.storeId) === sid && telefoneComparavel(p.phone || p.telefone) === alvo) {
      candidatos.push({
        moduleId:"prospeccao", storeId:Number(p.storeId), phone:p.phone || p.telefone,
        record:p, t:quando(p.createdAt || p.date || p.data_criacao), ordem:3,
      });
    }
  }
  if (!candidatos.length) return null;
  candidatos.sort((a, b) => (a.t - b.t) || (a.ordem - b.ordem));
  const { moduleId, storeId:recordStoreId, channelStoreId, recordId, phone:recordPhone, record } = candidatos[0];
  return { moduleId, storeId:recordStoreId, channelStoreId:channelStoreId || recordStoreId,
    recordId:recordId || null, phone:recordPhone, record };
}

export function abaDaConversa(input) {
  return conversaDaOrigem(input)?.moduleId || "inbox";
}